import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function ({ renderTitle, children }) {
  const navigate = useNavigate()

  if (!Array.isArray(children)) {
    children = [children]
  }

  return (
    <nav className='level context-menu pt-5'>
      <div className="level-left flex items-center gap-2">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full hover:bg-gray-100 transition"
        >
          <ArrowLeft size={20} className='cursor-pointer' />
        </button>

        {renderTitle && renderTitle()}
      </div>
      <div className='level-right'>
        {children.map((child, index) => (
          <div className='level-item' key={index}>
            {child}
          </div>
        ))}
      </div>
    </nav>
  )
}
